export const MAX_DECIMAL = 999999999999.99;
